"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MENU_TYPE = exports.MENU_CODE = exports.MENU_CATEGORY = void 0;
const MENU_CODE = exports.MENU_CODE = {
  FRONTEND_TOP: 'FRONTEND_TOP',
  BACKEND_TOP: 'BACKEND_TOP'
};
const MENU_CATEGORY = exports.MENU_CATEGORY = {
  FRONTEND: 0,
  BACKEND: 1
};
const MENU_TYPE = exports.MENU_TYPE = {
  CATEGORY: 0,
  MENU: 1,
  BUTTON: 2
};